import React, { useState } from 'react';
import {
  Box, IconButton, MenuItem, Select, Table, TableBody, TableCell, TableHead,
  TableRow, Typography,
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { CardWrapper, formatBRL } from '../../UI';
import { RECALCULOS } from '../../../mocks/processos.mock';
import * as C from '../../../theme/colors.constants';

/**
 * Aba Recálculos do Processo — print `grid_check_recalculos.png`.
 *
 * Tabela com linhas zebradas e a mesma paginação da aba Documentos. No print o
 * total é 22 registros; aqui uso os 5 do mock repetindo o padrão de contagem
 * para preservar a leitura da paginação.
 */
const TOTAL_SIMULADO = 22;

export default function AbaRecalculos() {
  const [porPagina, setPorPagina] = useState(5);
  const [pagina, setPagina] = useState(0);

  const ultimaPagina = Math.ceil(TOTAL_SIMULADO / porPagina) - 1;
  const inicio = pagina * porPagina;

  return (
    <CardWrapper>
      <Box sx={{ overflowX: 'auto' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Data do Recálculo</TableCell>
              <TableCell>Data Base</TableCell>
              <TableCell>Fase</TableCell>
              <TableCell>Nome do Responsável</TableCell>
              <TableCell>Motivo do Recálculo</TableCell>
              <TableCell>Tipo de Desconto</TableCell>
              <TableCell align="right">Valor Recalculado</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {RECALCULOS.map((r, i) => (
              <TableRow
                key={`${r.dataRecalculo}-${i}`}
                hover
                sx={{ backgroundColor: i % 2 === 1 ? C.paleGrey : undefined }}
              >
                <TableCell>{r.dataRecalculo}</TableCell>
                <TableCell>{r.dataBase}</TableCell>
                <TableCell>{r.fase}</TableCell>
                <TableCell>{r.responsavel}</TableCell>
                <TableCell>{r.motivo}</TableCell>
                <TableCell>{r.tipoDesconto}</TableCell>
                <TableCell align="right" sx={{ fontWeight: 700 }}>{formatBRL(r.valor)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>

      <Box sx={{
        display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 2, mt: 2,
      }}
      >
        <Typography variant="body2">Linhas por página:</Typography>
        <Select
          size="small"
          variant="standard"
          value={porPagina}
          onChange={(e) => { setPorPagina(Number(e.target.value)); setPagina(0); }}
          sx={{ minWidth: 56 }}
        >
          {[5, 10, 25].map(n => <MenuItem key={n} value={n}>{n}</MenuItem>)}
        </Select>
        <Typography variant="body2">
          {inicio + 1}
          –
          {Math.min(inicio + porPagina, TOTAL_SIMULADO)}
          {' '}
          de
          {TOTAL_SIMULADO}
        </Typography>
        <IconButton size="small" disabled={pagina === 0} onClick={() => setPagina(p => p - 1)} sx={{ color: C.navy }}>
          <ChevronLeftIcon />
        </IconButton>
        <IconButton size="small" disabled={pagina >= ultimaPagina} onClick={() => setPagina(p => p + 1)} sx={{ color: C.navy }}>
          <ChevronRightIcon />
        </IconButton>
      </Box>
    </CardWrapper>
  );
}
